/**
 * Handles from submission and replace the old form with the new partial
 * @module lib/form_handler
 */

import { replaceContent } from './dom';

/** CSS selector for the element on which to listen to the UJS events*/
const SELECTOR = `.js-form-to-handle`;
/** Element to replace with the loaded content */
const REPLACEABLE_SELECTOR = '.js-form-to-handle__replaceable-content';

export default function setupFormHandler() {
  $(document).on('ajax:beforeSend', SELECTOR, ({ currentTarget, target }) => {
    if (currentTarget === target || $(target).closest(SELECTOR).length > 0) {
      currentTarget.setAttribute('aria-busy', 'true');
    }
  });

  const handleReplaceableContent = ({ currentTarget, target, detail }) => {
    if (currentTarget === target) {
      const [response] = detail;
      const replacement = response.body.children[0];
      const replaceable = document.querySelector(REPLACEABLE_SELECTOR);
      if (replacement && replaceable) {
        replaceContent(replacement, replaceable);
      }
    }
  };

  $(document).on('ajax:success', SELECTOR, handleReplaceableContent);
  $(document).on('ajax:error', SELECTOR, handleReplaceableContent);

  $(document).on('ajax:complete', SELECTOR, ({ currentTarget, target }) => {
    if (currentTarget === target || $(target).closest(SELECTOR).length > 0) {
      currentTarget.removeAttribute('aria-busy');
    }
  });
}
